import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography
} from '@mui/material';
import { downGradeOfferModalSxs, infoModalSxs } from '../newChangePlan';
import {
  downGradeOfferModalTexts,
  infoModalTexts,
  paths,
  SEOSpaceLocal
} from 'src/common/config/TextMessage';
import { useState } from 'react';
import { RootState } from 'src/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import {
  downgradeDeactivateOffers,
  getAddonDetails,
  getSubscriptionDetailsStripe
} from 'src/common/Scraper';
import CommonAlert from 'src/common/CommonAlert';
import {
  setAddonDetails,
  setScanDetails,
} from 'src/redux/counterSlice';
import {
  isLocalSeoUser,
  openNewTab,
  setProgressCalculation
} from 'src/common/config/FunctionHelper';
import { setStateStripeSubscription } from 'src/redux/userReducer';
import { useNavigate } from 'react-router';
import { setOfferApplied } from 'src/redux/dashboard';
import { useUserDetails } from 'src/hooks/apiHooks/useUserDetails';

export const FacingBugs = ({
  isFromDeactivate = false,
  selectedTimeLine = '',
  handCloseModal = () => {},
  handleChangePlanModal = () => {},
  isFacingBugsFieldErrorFromOfferModal,
  setIsFacingBugsFieldErrorFromOfferModal,
  isMinCharFacingBugsErrorFromOfferModal,
  setIsMinCharFacingBugsErrorFromOfferModal,
  facingBugsFeatureFromOfferModal,
  setFacingBugsFeatureFromOfferModal,
  setIsOfferApplied
}) => {
  const [facingBugsFeature, setFacingBugsFeature] = useState<string>('');
  const [isFacingBugsFieldError, setIsFacingBugsFieldError] = useState(null);
  const [isMinCharFacingBugsError, setIsMinCharFacingBugsError] =
    useState(null);
  const [loading, setLoading] = useState(null);
  const [responseMessage, setResponseMessage]: any = useState(null);
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  const { refetch: refetchUserDetails } = useUserDetails({ enabled: false });
  const isLocalSeo = isLocalSeoUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleChangeFacingBugsFeatureReason = (e) => {
    setFacingBugsFeature(e.target.value);
    setFacingBugsFeatureFromOfferModal(e.target.value);
    if (e.target.value?.length > 0) {
      setIsFacingBugsFieldError(false);
      setIsFacingBugsFieldErrorFromOfferModal(false);
    }
    if (e.target.value?.length >= 30) {
      setIsMinCharFacingBugsError(false);
      setIsMinCharFacingBugsErrorFromOfferModal(false);
    }
  };
  const handleRedeemOffer = async () => {
    if (facingBugsFeature?.length == 0) {
      setIsFacingBugsFieldError(true);
      setIsFacingBugsFieldErrorFromOfferModal(true);
      return;
    }
    if (facingBugsFeature?.length < 30) {
      setIsMinCharFacingBugsError(true);
      setIsMinCharFacingBugsErrorFromOfferModal(true);
      return;
    }
    setLoading(true);
    setIsOfferApplied(true);
    const payload = {
      subscriptionId: stripeSubscriptionDetails?.subscription_id,
      selectedDowngradeReason: 'Facing Bugs',
      planId: stripeSubscriptionDetails?.plan_name?.id,
      downgradeFeedback: facingBugsFeature,
      isFromDeactivate: isFromDeactivate
    };
    const downgradeDeactivateOffersResponse: any =
      await downgradeDeactivateOffers(payload);

    setResponseMessage({
      status: downgradeDeactivateOffersResponse?.status,
      message: downgradeDeactivateOffersResponse?.message
    });
    if (downgradeDeactivateOffersResponse?.status == 'success') {
      const subscriptionDetailsStripe = await getSubscriptionDetailsStripe();
      if (subscriptionDetailsStripe != undefined) {
        dispatch(setStateStripeSubscription(subscriptionDetailsStripe));
      } else {
        dispatch(setStateStripeSubscription({}));
      }
      if (isFromDeactivate) {
        const { data: userDetailsResponse } = await refetchUserDetails();
        if (isPremiumUser) {
          // Fetch additional scan details for premium users
          let addonScan = await getAddonDetails();
          let getProgressScore = setProgressCalculation(
            userDetailsResponse,
            addonScan
          );
          dispatch(setScanDetails(getProgressScore));
          dispatch(setAddonDetails(addonScan));
        }
      }
    }

    setIsFacingBugsFieldError(false);
    setIsFacingBugsFieldErrorFromOfferModal(false);
    setIsMinCharFacingBugsError(false);
    setIsMinCharFacingBugsErrorFromOfferModal(false);

    setTimeout(() => {
      setLoading(false);
      setIsOfferApplied(false);
      setResponseMessage(null);
      if (downgradeDeactivateOffersResponse?.status == 'success') {
        openNewTab(downGradeOfferModalTexts?.facingBugsLink);
        dispatch(setOfferApplied({ open: true }));
        navigate(paths.dashboard);
        handCloseModal();
        handleChangePlanModal();
      }
    }, 3000);
  };
  return (
    <>
      <Typography sx={downGradeOfferModalSxs?.offerCardHeadTextSx}>
        {downGradeOfferModalTexts?.experienceBugs}
      </Typography>
      <Typography sx={downGradeOfferModalSxs?.offerCardDescTextSx}>
        {downGradeOfferModalTexts?.receiveFree}
      </Typography>
      <Box>
        <TextField
          fullWidth
          multiline
          variant="outlined"
          sx={{
            mt: 1,
            '& .MuiInputBase-root': {
              borderRadius: '6px',
              //maxHeight: '42px'
              paddingTop: '14px',
              paddingBottom: '14px'
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor:
                isFacingBugsFieldError || isFacingBugsFieldErrorFromOfferModal
                  ? 'var(--color-error-dark)'
                  : 'var(--color-text-secondary)'
            }
          }}
          InputProps={{
            style: { ...infoModalSxs?.placeHolderText } // Sets placeholder font size
          }}
          placeholder={
            isLocalSeo
              ? `Tell us why you're downgrading to help us improve ${SEOSpaceLocal}`
              : "Tell us why you're downgrading to help us improve SEOSpace"
          }
          value={facingBugsFeature}
          onChange={(e) => {
            const inputValue = e.target.value.slice(0, 200); // Auto-trims input to 200 chars
            if (inputValue.length <= 200) {
              handleChangeFacingBugsFeatureReason({
                target: { value: inputValue }
              });
            }
          }}
          onClick={(e) => e.stopPropagation()} // Prevents ListItem click event
          error={facingBugsFeature?.length >= 200}
          helperText={
            facingBugsFeature?.length >= 200
              ? 'You have reached the maximum limit of 200 characters.'
              : ''
          }
          autoComplete="off" // Turns off autocomplete
        />

        {(isFacingBugsFieldError ||
          isFacingBugsFieldErrorFromOfferModal ||
          isMinCharFacingBugsError ||
          isMinCharFacingBugsErrorFromOfferModal) && (
          <Box sx={infoModalSxs?.noSelectionFieldErrorBox}>
            <img
              src={
                process.env.PUBLIC_URL +
                `/static/images/icons/red-info-dark.svg`
              }
              alt="Icon"
              style={infoModalSxs?.imgBoxSx}
            />
            <Typography sx={infoModalSxs?.noSelectionError}>
              {isMinCharFacingBugsError ||
              isMinCharFacingBugsErrorFromOfferModal
                ? infoModalTexts?.charError
                : infoModalTexts?.otherReasonError}
            </Typography>
          </Box>
        )}
      </Box>
      {responseMessage?.status && (
        <Box className="mt-1">
          <CommonAlert
            severity={responseMessage?.status}
            message={responseMessage?.message}
          />
        </Box>
      )}
      <Button
        variant="contained"
        fullWidth
        sx={downGradeOfferModalSxs?.offerCardBtnSx}
        onClick={handleRedeemOffer}
      >
        {loading ? (
          <CircularProgress color="inherit" size={24} />
        ) : (
          downGradeOfferModalTexts?.redeemOffer
        )}
      </Button>
    </>
  );
};
